var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.reviewVisible,
        "show-close": false,
        close: _vm.back,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.reviewVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "back" }, [
        _c("div", { staticClass: "tag", on: { click: _vm.back } }, [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v("Back")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _vm.action
          ? _c("div", { staticClass: "content" }, [
              _vm._v(
                "After agreeing to the refund, the ShopVidi platform will refund the retailer within 1-3 working days"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.action
          ? _c("div", { staticClass: "content" }, [
              _vm._v(
                "If you disagree with the refund, you can negotiate with the retailer to revise the refund and re-initiate"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.action
          ? _c(
              "div",
              { staticClass: "reason" },
              [
                _c("div", { staticClass: "title" }, [_vm._v("Denial Reason")]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    placeholder: "Please enter denial reason",
                    maxlength: "500",
                    "show-word-limit": ""
                  },
                  on: { input: _vm.checkReason },
                  model: {
                    value: _vm.reason,
                    callback: function($$v) {
                      _vm.reason = $$v
                    },
                    expression: "reason"
                  }
                }),
                _vm._v(" "),
                _vm.showTips
                  ? _c("div", { staticClass: "tips" }, [
                      _vm._v("Please enter denial reason")
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex_all" },
          [
            _vm.action
              ? _c(
                  "el-button",
                  {
                    staticClass: "back_button",
                    attrs: { type: "primary" },
                    on: { click: _vm.reviewServiceOrder }
                  },
                  [_vm._v("Confirm Refund")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.action
              ? _c(
                  "el-button",
                  {
                    staticClass: "back_button",
                    attrs: { type: "primary" },
                    on: { click: _vm.reviewServiceOrder }
                  },
                  [_vm._v("Refusing a refund")]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0adc57c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0adc57c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/review-dialog.vue
// module id = 9YyG
// module chunks = 2